import React from 'react';
import PropTypes from 'prop-types';

import DownPaymentInputController from '../../../containers/inputs/DownPaymentInputController';
import AprPercentInputController from '../../../containers/inputs/AprPercentInputController';
import TermSelectController from '../../../containers/inputs/TermSelectController';
import { PRICE, EST_MONTHLY_PAYMENT, RESET } from '../../../constants/labels';

import './PaymentCalculator.scss';

class PaymentCalculator extends React.Component {
	render() {
		const {
			price,
			monthlyPayment,
			resetCalculator,
			showDisclaimer
		} = this.props;

		const disclaimerElem = showDisclaimer ? (
			<p className="payment-calculator-support-text">
				Estimated Monthly Payment
				<sup>2</sup> will depend on vehicle make and model and will be
				determined upon actual vehicle inspection. All payments are
				estimates. Tax, title and any other fees are extra.
			</p>
		) : (
			''
		);

		return (
			<div className="payment-calculator">
				<form>
					<div className="row">
						<div className="col-md-5">
							<DownPaymentInputController
								id="pc-inputDownPayment"
								className="form-control"
							/>
							<AprPercentInputController
								inputClassName="form-control"
								inputId="pc-APR"
							/>
							<TermSelectController
								className="form-control"
								id="pc-selectTerm"
							/>
						</div>
						<div className="col-md-7">
							<div className="payment-calculator-pricebox">
								<div className="pc-pricetext">{PRICE}</div>
								<div className="pc-pricenumber">{price}</div>
							</div>
							<div className="payment-calculator-pricebox pc-monthly-payment">
								<div className="pc-pricetext">
									{EST_MONTHLY_PAYMENT}
									<sup>2</sup>
								</div>
								<div className="pc-pricenumber">
									{monthlyPayment}
								</div>
							</div>
						</div>
					</div>
					<div className="form-group form-group-reset-button">
						<button
							type="button"
							className="btn btn-lnk pc-reset"
							onClick={() => {
								resetCalculator();
							}}
						>
							{RESET}
						</button>
					</div>
					{disclaimerElem}
				</form>
			</div>
		);
	}
}

PaymentCalculator.propTypes = {
	price: PropTypes.string.isRequired,
	monthlyPayment: PropTypes.string.isRequired,
	resetCalculator: PropTypes.func.isRequired,
	showDisclaimer: PropTypes.bool.isRequired
};

export default PaymentCalculator;



// WEBPACK FOOTER //
// ./src/components/views/loaded/PaymentCalculator.jsx